export default function auth ({ next, router }) {
  if (!localStorage.getItem('stateAntiFraud')) {
    return router.push({ name: 'login' })
  }

  return next()
}
